export const ROUTER_QUESTIONNAIRE_PREFIX = '/invitation-token'; // 问卷
export const ROUTER_QUESTIONNAIRE = `${ROUTER_QUESTIONNAIRE_PREFIX}/:id`; // 问卷

export const ROUTER_VERIFICATION = '/verification'; // 验证
export const ROUTER_AGREEMENT = '/agreement'; // 协议
export const ROUTER_OUTSIDE_SUCCESS = '/outside-successfully'; // 授信成功
// habc
export const ROUTER_HABC_QUESTIONNAIRE_PREFIX = '/invitation-code'; // 问卷
export const ROUTER_HABC_QUESTIONNAIRE = `${ROUTER_HABC_QUESTIONNAIRE_PREFIX}/:id`; // 问卷
export const ROUTER_HABC_PREFIX = '/hase';
export const ROUTER_VERIFY_PROFILE = `${ROUTER_HABC_PREFIX}/verify-profile`; // 验证授信
export const ROUTER_CREATE_PROFILE = `${ROUTER_HABC_PREFIX}/create-profile`; // 创建授信
export const ROUTER_HABC_SUCCESS = `${ROUTER_HABC_PREFIX}/successfully`; // 授信成功

export const ROUTER_HASE_AGREEMENT = `${ROUTER_HABC_PREFIX}/agreement`; // 协议
